import { ROUTES } from './routes'

/**
 * `/_/certificates/verify/{code}`: a certificate's public verification page
 * (F-42 §7.3). Public, no session, on the community's own domain. QR codes
 * already printed say `/verify/{code}`, which redirects here (`routes.js`).
 */
export const VERIFY_PATH_PREFIX = ROUTES.certificatesVerify

export const isVerifyPath = (path: string): boolean => path.startsWith(VERIFY_PATH_PREFIX)

/** The code as typed in the URL, upper-cased; the API compares it as stored. */
export const verifyCodeFrom = (path: string): string =>
  decodeURIComponent(path.slice(VERIFY_PATH_PREFIX.length).split(/[/?#]/)[0] || '').trim().toUpperCase()
